import { mapState } from 'vuex'
import maNavbarCategory from '@/components/navbarCategories'
import maAcceptDamages from '@/components/button-blue'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
  name: 'damageResultUptec',

  mixins: [flowMixin],

  components: {
    maNavbarCategory,
    maAcceptDamages
  },

  data: function () {
    return {
      titleCategory: ''
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyObjUptec: 'objUptec'
    })
  },

  methods: {
    handleClickGoToDamagesView () {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },

    handleClickPrevPage () {
      const damageMobilierViewName = 'damageMobilier'
      const name = this.getDamageName
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierViewName, { propertyType, name, damageType })
    },

    /**
     * Gets the list with all the images and bases on its name it returns a list for each name
     */
    getImageSrc (imgName, imgList) {
      let imgSrc = []
      imgList.forEach(img => {
        if (img.imageType === imgName) {
          imgSrc.push(img.imageContent)
        }
      })
      return imgSrc
    }
  }
}
